import { useEffect, useState } from "react";
import { z } from "zod";
import { axiosFunction } from "../components/commonFunctions";
import { v2ReactURL } from "../utils/constant";

const BranchSchema = z.object({
  userFrontId: z.number(),
  name: z.string(),
});

const BranchListSchema = z.array(BranchSchema);

interface ModifiedBranch {
  id: number;
  name: string;
  userFrontId: number;
}


const useBranchListApi = () => {
  const [branchLocationList, setBranchLocationList] = useState<ModifiedBranch[]>([]);
  const [searchBranchResults, setSearchBranchResults] = useState<ModifiedBranch[]>([]);

  useEffect(() => {
    const fetchBranchList = async () => {
      const res = await axiosFunction(
        `${v2ReactURL}/userrole/branchidlist/Contact`,
        "GET"
      );
      const validatedData = BranchListSchema.safeParse(res?.data?.response);
      if(validatedData.success) {
        const modifiedResults = validatedData?.data?.map((row): ModifiedBranch => {
          return {
            ...row,
            id: row.userFrontId,
            name: row.name,
          } ; 
        });
  
        setBranchLocationList(modifiedResults);
        setSearchBranchResults(modifiedResults);

      } else {
        console.error("API response validation failed:", validatedData.error);
      }
    };

    fetchBranchList();
  }, []);

  return {
    branchLocationList,
    setBranchLocationList,
    searchBranchResults,
  };
};

export default useBranchListApi;
